export namespace UI {
  export class Form {
    isLoading: boolean = false;
    isSubmitted: boolean = false;
    error: string = '';

    submit() {
      this.isSubmitted = true;
    }
  }

  export class FormField {
    value: string = '';
    error: string = '';
    validationEnabled: boolean = false;
    public validateFunc: Function = null;

    constructor(value?: string, validate?: Function) {
      this.value = value || '';
      this.validateFunc = validate ?? null;
    }

    reset() {
      this.value = '';
      this.error = '';
    }

    resetError() {
      this.error = '';
    }

    validate() {
      if (this.validateFunc === null) return;

      this.error = this.validateFunc(this.value);
    }
  }

  export class CheckboxField {
    value: boolean = false;
    isRequired: boolean = false;
    isValidationEnabled: boolean = false;

    constructor(value: boolean = false, isRequired: boolean = false) {
      this.value = value;
      this.isRequired = isRequired;
    }

    isValid() {
      if (this.isRequired && !this.value) {
        return false;
      }

      return true;
    }
  }

  export class DropdownItem<T = any> {
    value: T;
    name: any;

    constructor(value: T, name?: any) {
      this.value = value;
      this.name = name != undefined ? name : String(value);
    }
  }
}

export namespace FormHelper {
  export interface IFormBase<T = Record<string, IField>> {
    isLoading: boolean;
    error: string;
    fields: T;
  }

  export function buildForm<T extends Record<string, IField>>(
    fields?: T,
  ): IFormBase<T> {
    return {
      isLoading: false,
      error: '',
      fields,
    };
  }

  export interface IFormField {
    value: string;
    error: string;
  }

  export interface ISelectField<T = object> {
    value: T;
    error: string;
  }

  export type IField = IFormField | ISelectField;

  export function buildFormField(value?: string): IFormField {
    return { value: value ?? '', error: '' };
  }

  export function buildSelectField<T>(value?: T): ISelectField<T> {
    return { value: value ?? null, error: '' };
  }
}
